function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "calendar_svg__a",
  d: "M18 7.273V4.545c0-.502-.448-.909-1-.909h-2v.91c0 .502-.448.909-1 .909s-1-.407-1-.91v-.909H7v.91c0 .502-.448.909-1 .909s-1-.407-1-.91v-.909H3c-.552 0-1 .407-1 .91v2.727h16zm0 1.818H2v8.182c0 .502.448.909 1 .909h14c.552 0 1-.407 1-.91v-8.18zM7 1.818h6V.91c0-.503.448-.91 1-.91s1 .407 1 .91v.908h2c1.657 0 3 1.221 3 2.727v12.728C20 18.779 18.657 20 17 20H3c-1.657 0-3-1.221-3-2.727V4.545C0 3.04 1.343 1.818 3 1.818h2V.91C5 .407 5.448 0 6 0s1 .407 1 .91v.908z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, React.createElement("mask", {
  id: "calendar_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#calendar_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#calendar_svg__a"
}), React.createElement("g", {
  fill: "#22272F",
  mask: "url(#calendar_svg__b)"
}, React.createElement("path", {
  d: "M-2-2h24v24H-2z"
})));

var SvgCalendar = function SvgCalendar(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/calendar.328a0e3d.svg";
export { SvgCalendar as ReactComponent };